import { alpha, styled as muiStyle } from '@mui/material/styles';
import { RadioProps, Radio as MuiRadio  } from '@mui/material';

export const StyledMuiRadio = muiStyle(MuiRadio)<RadioProps>(({ theme }) => ({
  '+ .MuiFormControlLabel-label': {
    lineHeight: `1`
  },
  'input[disabled]': {
    opacity: 0
  }
}));

export const StyledIcon = muiStyle('span')<RadioProps>(({ theme }) => ({
  width: 18,
  height: 18,
  border: `2px solid ${theme.palette.secondary[300]}`,
  boxSizing: `border-box`,
  borderRadius: '50%',
  '.Mui-disabled &': {
    borderColor: alpha(theme.palette.secondary[800], 0.16),
  },
}));

export const StyledCheckedIcon = muiStyle(StyledIcon)<RadioProps>(({ theme }) => ({
  display: `inline-flex`,
  alignItems: `center`,
  justifyContent: `center`,
  backgroundColor: '#fff',
  '&:before': {
    display: 'block',
    width: 10,
    height: 10,
    borderRadius: `50%`,
    backgroundColor: theme.palette.secondary[800],
    content: '""',
    '.Mui-disabled &': {
      opacity: `.48`
    }
  },
  '.Mui-disabled &': {
    borderColor: alpha(theme.palette.secondary[800], 0.16),
  }
}));
